module.exports = __webpack_public_path__ + "static/media/focused.23d6e35b.svg";